import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AccountInfo } from '@azure/msal-common';
import { ObtenerUsuarioService } from './obtener-usuario.service';
import { ObtenerImagenPerfilService } from './obtener-imagen-perfil.service';
import { MsalService } from '@azure/msal-angular';
import { GestionMenu } from '../menu/menu/elemento-menu';
import { Router } from '@angular/router';
import { ObtenerImagenCorporativaService } from '../../../application/public/services/obtener-imagen-corporativa.service';
import { PanelLateralService } from '../../../application/shared/modules/panel-lateral/panel-lateral.service';
import { AyudaComponent } from '../../../domain/shared/ayuda/ayuda.component';
import { ObtenerAyudaService } from './obtener-ayuda.service';
import { RutaAyuda } from './ruta-ayuda';
import { ObtenerTooltipService } from './obtener-tooltip.service';
import { MarcarTooltipService } from './marcar-tooltip.service';
import { PanelMenuComponent } from '../menu/panel-menu/panel-menu.component';
import { ElementoMenuHijo } from '../menu/panel-menu/elemento-menu-hijo';
import { MenuComponent } from '../menu/menu/menu.component';
import { Permiso } from '../../../domain/administrador/permisos/permiso';
import { ObtenerConfiguracionSalesForceService } from '../../../application/public/services/obtener-configuracion-sales-force.service';

@Component({
  selector: 'app-pantalla-con-menu',
  templateUrl: './pantalla-con-menu.component.html',
  styleUrls: ['./pantalla-con-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PantallaConMenuComponent implements OnInit {
  public usuarioMSAL!: AccountInfo | null;
  public imagenPerfil!: any;
  private menuAbierto = false;
  public logoCuadrado: string | null = null;
  public logoBase: string = 'assets/img/logo-lunia-blanco.svg';
  public soloLogoBase: boolean = false;
  public rutaActual: string = '';
  protected rutaWordpress: string | undefined;
  private rutasWordpress = [] as RutaAyuda[];
  protected mostrarTooltip: boolean = false;
  @ViewChild(PanelMenuComponent) panelMenu!: PanelMenuComponent;
  @ViewChild(MenuComponent) menu!: MenuComponent;
  protected permisoSalesForce!: Permiso;
  protected authProvider!: string | null;

  constructor(
    private obtenerUsuarioService: ObtenerUsuarioService,
    private obtenerImagenPerfilService: ObtenerImagenPerfilService,
    private msalService: MsalService,
    private router: Router,
    private obtenerImagenCorporativaService: ObtenerImagenCorporativaService,
    private obtenerAyudaService: ObtenerAyudaService,
    public panelLateralService: PanelLateralService,
    private obtenerTooltipService: ObtenerTooltipService,
    private marcarTooltipService: MarcarTooltipService,
  ) {
    if (
      this.obtenerImagenCorporativaService.obtenerImagenCorporativa(
        'logoCuadrado',
      )
    ) {
      this.logoCuadrado =
        this.obtenerImagenCorporativaService.obtenerImagenCorporativa(
          'logoCuadrado',
        );
    }
    if (
      this.obtenerImagenCorporativaService.obtenerImagenCorporativa('logoBase')
    ) {
      this.logoBase =
        this.obtenerImagenCorporativaService.obtenerImagenCorporativa(
          'logoBase',
        );
    }
    this.soloLogoBase = this.logoCuadrado === null && this.logoBase !== null;
  }

  public ngOnInit(): void {
    this.rutaActual = this.router.url;
    this.usuarioMSAL = this.obtenerUsuarioService.__invoke() as AccountInfo;
    const permiso = sessionStorage.getItem('permiso');
    if (permiso) {
      this.permisoSalesForce = JSON.parse(permiso);
    }
    this.authProvider = sessionStorage.getItem('auth_provider');
    this.getImagenPerfil();
    this.obtenerTooltip();
    this.obtenerRutasAyuda();
    this.router.events.subscribe((event) => {
      this.rutaActual = this.router.url;
    });
  }

  public getImagenPerfil(): void {
    if (this.usuarioMSAL) {
      this.obtenerImagenPerfilService
        .__invoke(this.usuarioMSAL!.localAccountId)
        .subscribe({
          next: (result: any) => {
            let urlCreator = window.URL || window.webkitURL;
            this.imagenPerfil = urlCreator.createObjectURL(result);
          },
          error: (error) => {
            this.imagenPerfil = null;
          },
        });
    }
  }

  async logout() {
    if (this.authProvider === 'salesforce') {
      alert('tengo que implementar el logout de salesforce');
    }
    sessionStorage.clear();
    await this.router.navigate(['login']);
  }

  public toogleOpcionesPerfil(): void {
    const opcionesPerfil = document.getElementById('opciones-perfil');
    opcionesPerfil?.classList.toggle('hidden');
  }

  public volverAlHome(): void {
    this.router.navigate(['/inicio']);
  }

  public toogleConversaciones(): void {
    this.menuAbierto = !this.menuAbierto;
    const conversaciones = document.getElementById('conversaciones');
    const overlay = document.getElementById('overlay');
    overlay?.classList.toggle('hidden');
    conversaciones?.classList.toggle('hidden');
  }

  public abrirAyuda(): void {
    const preview = this.panelLateralService.loadComponent(AyudaComponent);
    this.panelLateralService.setSize('lg');
    this.panelLateralService.setTitulo('Centro de ayuda');

    preview.instance.rutaWordpress = this.rutaWordpress;
  }

  protected rutaActualTieneAyuda(): boolean {
    const ruta = `/${this.rutaActual.split('/')[1]}`;
    this.rutaWordpress = this.rutasWordpress.find(
      (r) => r.rutaAngular === ruta,
    )?.rutaWordpress;
    return this.rutasWordpress.some((r) => r.rutaAngular === ruta);
  }

  private obtenerRutasAyuda() {
    this.obtenerAyudaService.__invoke().subscribe({
      next: (rutas) => {
        this.rutasWordpress = rutas;
      },
    });
  }

  private obtenerTooltip() {
    this.obtenerTooltipService.__invoke().subscribe({
      next: (mostrarTooltip) => {
        this.mostrarTooltip = mostrarTooltip;
      },
    });
  }

  protected marcarTooltip(marcado: boolean) {
    if (marcado) {
      this.marcarTooltipService.__invoke().subscribe({
        next: () => {
          this.obtenerTooltip();
        },
      });
    }
  }

  protected gestionarPanelMenu($event: GestionMenu) {
    // Guard: Prevenir errores si los ViewChild no están inicializados
    if (!this.panelMenu) return;

    if ($event.opcion?.elementosHijos) {
      for (let elementoHijo of $event.opcion.elementosHijos) {
        elementoHijo.activo = elementoHijo.ruta === this.rutaActual;
      }
    }
    this.panelMenu.elementosHijos = $event.opcion
      ? $event.opcion.elementosHijos
      : null;
    this.panelMenu.descripcionOpcionMenu = $event.opcion
      ? $event.opcion.descripcion
      : null;
    this.panelMenu.widget = $event.opcion ? $event.opcion.widget : null;
    this.panelMenu.abierto = $event.abierto;
  }

  protected cerrarPanelYMarcarElementoPadreComoActivo() {
    // Guard: Prevenir errores si los ViewChild no están inicializados
    if (!this.panelMenu || !this.menu) return;

    this.panelMenu.abierto = false;
    this.menu.menuActivo = null;
  }
}
